import { useRadioPlayerContext } from "../../providers/RadioPlayerContext";
import { CircleCloseIcon } from "../icons";

const Header = () => {
  const { currentTrack } = useRadioPlayerContext();

  const handleClose = () => {
    console.log("first")
    window.parent.postMessage({ type: "CLOSE_IFRAME" }, "*");
  };

  return (
    <div className="flex justify-between py-3">
      <div className="flex flex-col gap-2">
        <span className="rounded-lg bg-[#2222224d] backdrop-blur-md py-1 px-2 text-lg font-semibold w-max">
          {currentTrack?.singer}
        </span>
        <span className="rounded-lg bg-[#2222224d] backdrop-blur-md py-1 px-2 w-max">
          {currentTrack?.title}
        </span>
      </div>
      <button onClick={handleClose} className="size-7 rounded-full bg-[#2222224d] !z-[99]">
        <CircleCloseIcon className="size-full" />
      </button>
    </div>
  );
};

export default Header;
